import { APP_PATH } from "./layerBasics";

// The static area page of a local authority in England or Wales (/uk/area/<slug>, built by
// python/scripts/build_area_pages.py), linked from the Big Picture's local authority popups.
// The slug is made exactly as ukmap.area_page_slug (sql/area_page.sql) makes it.
export const AREA_PAGES_PATH = APP_PATH + '/area/';
const LAD_CODE = /^(E0[6-9]|W06)\d{6}$/;

export const areaPageSlug = (name) => String(name || '')
    .replace(/, (City|County) of$/, '').toLowerCase()
    .replace(/['.]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

// The page's address for an area code and name, or null for any other area (Scotland,
// Northern Ireland, neighbourhoods)
export const areaPageUrl = (code, name) =>
    LAD_CODE.test(String(code || '')) && areaPageSlug(name) ? AREA_PAGES_PATH + areaPageSlug(name) : null;

// The link under a popup
export const areaPageLinkHTML = (code, name, escapeHTML) => {
    const url = areaPageUrl(code, name);
    return url ? '<a class="areaPageLink" href="'+url+'" style="display:block; margin-top:-2px; font-size:.78em; font-weight:500; color:#1f7a5a; text-underline-offset:3px">'+
        escapeHTML(name)+' area page: prices, rents, crime &rarr;</a>' : '';
};
